<template>
  <div class="message-box">
    <div class="content-center">
      <p class="undefined-message">
        Unknowns Message
      </p>
      <p class="content-message">
        {{ message.message }}
      </p>
      <div class="content-detail">
        <p>{{ message.createdAt | formatShortDate }} </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  props: {
    message: {
      type: Object,
      default: () => ({
        message: 'something',
        createdAt: '2021-05-01T00:00:00.000Z',
      }),
    },
  },
  setup() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.message-box {
  display: flex;
  justify-content: center;

  .undefined-message{
    margin-bottom: 0.5em;
  }
  .content-center {
    text-align: center;
  }

  .message-box-left {
  }

  .message-box-right {
  }

  .content-detail {
    text-align: center;
    margin-top: -0.7rem !important;
  }

  .content-message {
    // padding: 1em;
    background: #c0392b;
    color: white;
    border-radius: 12px;
    // padding: 0.5rem;
    // padding-left: 1rem;
    // padding-right: 1rem;
    padding: 5px 25px;
    text-align: center;
    white-space: break-spaces;

  }
}

//.operator-message-box {
//  align-self: flex-end;
//  display: flex;
//  .content {
//  }
//  .detail {
//  }
//  .message {
//    background: #8d5185;
//    color:white
//  }
//}
</style>
